
import { supabase } from "@/integrations/supabase/client";

// Generate a unique session ID for tracking user interactions
const getSessionId = (): string => {
  let sessionId = sessionStorage.getItem('search_session_id');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('search_session_id', sessionId);
  }
  return sessionId;
};

// Track search interactions
export const trackSearchInteraction = async (data: {
  interactionType: 'search' | 'view' | 'click';
  searchQuery?: string;
  searchCriteria?: any;
  resultsCount?: number;
  clickedVacationId?: number;
  vacationPosition?: number;
}) => {
  try {
    const sessionId = getSessionId();
    
    await supabase.from('search_analytics').insert({
      user_session: sessionId,
      search_query: data.searchQuery || '',
      search_criteria: data.searchCriteria || null,
      results_count: data.resultsCount || 0,
      clicked_vacation_id: data.clickedVacationId || null,
      vacation_position: data.vacationPosition || null,
      interaction_type: data.interactionType
    });

    console.log('Search interaction tracked:', data.interactionType);
  } catch (error) {
    console.warn('Failed to track search interaction:', error);
  }
};

// Update search performance metrics
export const updateSearchPerformance = async (query: string, resultsCount: number, hadClick: boolean = false) => {
  try {
    await supabase.functions.invoke('update-search-performance', {
      body: { query, resultsCount, hadClick }
    });
  } catch (error) {
    console.warn('Failed to update search performance:', error);
  }
};
